import React, { useState } from "react";

function Hidden({ data }) {
  const [element, setElement] = useState(data);

  return (
    <div className="form-hidden">
      <input
        className="form-view"
        type="hidden"
        label={element.properties.label}
        data={JSON.stringify(element)}
      />
    </div>
  );
}

export default Hidden;
